import { Version } from "./../../version/index";
import StorageUtils from "@services/storage";
import { callSubmit, deleteObjectProperties, getISODate } from "../../general/index";
import { api, state, temp, ui } from "./../../../interfaces/interfaces";
import { autoAllocateLookup, checkReducedRate } from "../../general/index";
import { serviceAgreement } from "../serviceAgreement_v2";
import { AddressUtils } from "../../address";
import ObjectsOperations from "../operations";
import JobI from "./interface";
import { serviceManager } from "@services/workers";
import bookingCycleMgr from "@services/bookingCycleMgr";
import { debounceStorage, questionsUtils } from "../../..";
import { importStateReducer } from "@reducers/stateReducer/operations";
import { importTempReducer } from "@reducers/tempReducer/operations";
import { importUIReducer } from "@reducers/uiReducer/operations";
import AppointmentDate from "../../appointmentDate";
import { dispatchSetMultipleState } from "@reducers/stateReducer";
import { dispatchSetSnackMsgError, dispatchSetSnackMsgSuccess } from "@reducers/uiReducer";
import {
  RightioWBSAPIModelsJobPatchInput,
  RightioWBSAPIModelsOtherPhoneCalls,
  RightioWBSAPIModelsSPSpJobsBookingGetIdRequest,
  RightioWBSAPIModelsSPSpJobsSetChargeRequest,
  StoredProceduresJobsInitialBookingParams,
} from "../../apis/wbs/endpoints";
import { logger } from "@services/workers/helpers";
import { FAILED_REASON_SAME_DAY_ATTENDANCE_SUNDAY } from "@src/constants";

const namespace = "JOB CLASS";

export class Job {
  public get notes(): string {
    let note = "";
    state.NotesCarePlan && (note += "CarePlan: " + state.NotesCarePlan + "\n");
    state.NotesPrevious && (note += "Previous JOB: " + state.NotesPrevious + "\n");
    state.NotesCaller && (note += "Caller: " + state.NotesCaller + "\n");
    state.NotesLandlord && (note += "Landlord Details: " + state.NotesLandlord + "\n");
    state.NotesRelated && (note += "Related Details: " + state.NotesRelated + "\n");
    state.NotesJob && (note += "Job Questions: " + state.NotesJob + "\n");
    state.NotesAppointment && (note += "Appointment: " + state.NotesAppointment + "\n");
    state.NotesOther && (note += "Other: " + state.NotesOther + "\n");
    state.NotesParking && (note += "Parking: " + state.NotesParking + "\n");
    state.NotesFailed && (note += "Failed: " + state.NotesFailed + "\n");
    return note;
  }

  async init(customerCLI: string, sessionId: string | null, eventId: number | null, signal: AbortSignal) {
    dispatchSetMultipleState({
      JobStatusId: 99,
      JobSoldBy: state.UserId,
      JobBookingSourceId: Version.getBookingSourceId(), //standard booking //Version.getApplicationId(),
      JobCustomerCLI: customerCLI,
    });
    const accountCode = state.Account?.accountCode || 44999;

    const body: RightioWBSAPIModelsSPSpJobsBookingGetIdRequest = {
      statusId: 99,
      userId: state.UserId,
      bookingSourceId: Version.getBookingSourceId(),
      accountCode,
      layoutId: 999,
      source: Version.appName(),
      callSource: "PUZZEL",
      internal_iq_session_id: sessionId ? sessionId : undefined,
      eventId: eventId ? eventId : undefined,
      customerCLI,
    };
    if (signal.aborted) return;
    // create a new job
    const response = await api.fetchSetBookingId(body);
    if (response && response.length > 0) {
      state.JobId = response[0].id || -1;
    }

    // get the job account information
    const accountResponse = await api.fetchSetupBooking({ AccountCode: accountCode });
    if (accountResponse) {
      const callTypeGroup = accountResponse?.[0].callTypeGroup;
      if (callTypeGroup === 3) {
        StorageUtils.saveToStorage({ type: "session", store: "temp", key: "spinner", value: { disabled: false } });
        dispatchSetSnackMsgError({
          ProblemMsg: "This a CARE CLUB account code! Please cancel this booking and create a new one.",
        });
      }

      // get the job call type information
      const callTypeResponse = await api.fetchCallTypesSp({
        callTypeGroup: callTypeGroup || undefined,
        jobTypeCode: "",
      });

      if (callTypeResponse) {
        state.CallTypeId = callTypeResponse[0]?.value;
      }
    }
  }

  async generateJobTypesObject() {
    let jobTypesArray: any[] = [];
    if (state.CallTypeId) {
      const tradeTypes = await api.fetchTradeTypes({
        accountCode: state.Account?.accountCode || 44999,
        callTypeId: state.CallTypeId,
      });
      if (tradeTypes) {
        const jobTypes = await api.fetchJobTypes();
        if (jobTypes) {
          for (const tradeType of tradeTypes) {
            const tradeCode = tradeType.value;
            if (tradeCode) {
              const groupTypes = await api.fetchTradeGroupsMap(tradeCode);
              if (groupTypes) {
                for (const groupType of groupTypes) {
                  const groupCode = groupType.value;
                  const matchingJobTypes = jobTypes
                    .filter(
                      (jobType) =>
                        jobType.jobGroupCode === groupCode && jobType.tradeCode === tradeCode && !jobType.isSystem
                    )
                    .map((jobType: any) => ({
                      ...jobType,
                      jobGroupDescription: groupType.key,
                      tradeDescription: tradeType.key,
                    }));
                  jobTypesArray = [...jobTypesArray, ...matchingJobTypes];
                }
              }
            }
          }
        }
      }
    }
  }

  async canAutoAllocate() {
    if (
      state.JobTradeCode !== "" &&
      state.JobTypeCode !== "" &&
      state.JobPostcode !== "" &&
      state.CallTypeId &&
      state.CallTypeId > 0
    ) {
      const body = {
        tradeCode: state.JobTradeCode,
        jobTypeCode: state.JobTypeCode,
        postcode: state.JobPostcode,
        callTypeId: state.CallTypeId,
        // date: state.JobDateTimeRequired
      };
      const autoAllocate = await api.fetchAutoAllocation(body);

      if (autoAllocate && autoAllocate.length > 0) {
        return true;
      }
    }
    return false;
  }

  async autoAllocate() {
    const canAutoAllocate = await this.canAutoAllocate();
    if (canAutoAllocate) state.JobStatusId = 100;
  }

  getTrace() {
    const charge = state.Charge;
    const rateDiscount = ui.RatesDiscount;
    const chargeReductionDiscount = state.ChargeReductionDiscount;
    const chargeReductionDiscountDetails = state.ChargeReductionDiscountDetails;
    const chargeTrace = state.ChargeTrace || "";
    let trace = chargeTrace;

    if (
      charge?.rate &&
      rateDiscount < charge.rate &&
      chargeReductionDiscount > 0 &&
      chargeReductionDiscount !== (charge.rate - rateDiscount)
    ) {
      trace = chargeTrace.replace(
        chargeReductionDiscountDetails,
        chargeReductionDiscountDetails.replace(
          chargeReductionDiscount.toFixed(2),
          `${(charge.rate - rateDiscount).toFixed(2)} Agent Override`
        )
      );
    }

    console.log("getTrace", trace);
    return trace;
  }

  postSave = async () => {
    //if rate or price are higher than 0...
    if (state.ChargeRate > 0 || state.ChargePrice > 0) {
      const dateTimeRequired = getISODate(state.JobDateTimeRequired);
      // original rate and price
      const body: RightioWBSAPIModelsSPSpJobsSetChargeRequest = {
        jobId: state.JobId,
        dateTimeRequired,
        rate: state.ChargeRate,
        price: state.ChargePrice,
        period: state.ChargeRatePeriod,
        subPeriod: state.ChargeRateSubPeriod,
        subRate1: state.ChargeRateSubRate1,
        subRate2: state.ChargeRateSubRate2,
        subRate3: state.ChargeRateSubRate3,
        isVATInclusive: state.ChargeIsVATInclusive,
        trace: state.Charge?.trace || "",
        userId: state.UserId,
        rateReductionDiscountId: 0,
        promoCodeDiscountId: 0,
      };
      const chargeId = await api.fetchJobsSetCharge(body);
      if (chargeId.length === 0) {
        logger.error(namespace, "Error saving rate information");
        dispatchSetSnackMsgError({
          ProblemMsg: "Error saving rate information",
        });
        return false;
      }
      // if rate is not equal to adjusted rate... or price is not equal to adjusted price...
      if (
        state.ChargeRate !== state.ChargeRateAdj
        // || state.ChargePrice !== state.ChargePriceAdj
      ) {
        // Add the rate information to the database
        const body: RightioWBSAPIModelsSPSpJobsSetChargeRequest = {
          jobId: state.JobId,
          dateTimeRequired,
          rate: state.ChargeRateAdj,
          price: state.ChargePrice,
          period: state.ChargeRatePeriod,
          subPeriod: state.ChargeRateSubPeriod,
          subRate1: state.ChargeRateSubRate1,
          subRate2: state.ChargeRateSubRate2,
          subRate3: state.ChargeRateSubRate3,
          isVATInclusive: state.ChargeIsVATInclusive,
          trace: `${this.getTrace()}`,
          // ChargePromoDiscountDetails
          userId: state.UserId,
          rateReductionDiscountId: state.ChargeRateReductionDiscountId,
          promoCodeDiscountId: state.ChargePromoDiscountId,
        };
        const chargeId = await api.fetchJobsSetCharge(body);
        if (chargeId.length === 0) {
          logger.error(namespace, "Error saving rate information");
          dispatchSetSnackMsgError({
            ProblemMsg: "Error saving rate information",
          });
          return false;
        }
      }
      if (
        state.ChargePrice !== state.ChargePriceAdj
        // || state.ChargePrice !== state.ChargePriceAdj
      ) {
        // Add the rate information to the database
        const body: RightioWBSAPIModelsSPSpJobsSetChargeRequest = {
          jobId: state.JobId,
          dateTimeRequired,
          rate: state.ChargeRate,
          price: state.ChargePriceAdj,
          period: state.ChargeRatePeriod,
          subPeriod: state.ChargeRateSubPeriod,
          subRate1: state.ChargeRateSubRate1,
          subRate2: state.ChargeRateSubRate2,
          subRate3: state.ChargeRateSubRate3,
          isVATInclusive: state.ChargeIsVATInclusive,
          trace: `${state.ChargeTrace}`,
          // ChargePromoDiscountDetails
          userId: state.UserId,
          rateReductionDiscountId: state.ChargeRateReductionDiscountId,
          promoCodeDiscountId: state.ChargePromoDiscountId,
        };
        const chargeId = await api.fetchJobsSetCharge(body);
        if (chargeId.length === 0) {
          logger.error(namespace, "Error saving rate information");
          dispatchSetSnackMsgError({
            ProblemMsg: "Error saving rate information",
          });
          return false;
        }
      }
    }

    // Allocation
    if (!(state.JobEngineerId === 0)) {
      // Add the allocation information to the database
      await api.fetchEngineersQueuesAddJobToAllocationQueue({
        jobId: state.JobId,
        userId: state.UserId,
        engineerId: state.JobEngineerId,
        comments: "Allocation on booking",
        machineName: Version.appNameShort(),
      });
    }
    // Requisitions
    if (state.ChargeRequisitionTypeId) {
      await api.fetchSendRequisition({
        jobId: state.JobId,
        userId: state.UserId,
        isEmail: state.ChargeRequisitionTypeId === 1,
        isFax: state.ChargeRequisitionTypeId === 2,
        machineName: Version.appNameShort(),
      });
    }
    return true;
  };

  finalizeBooking = async () => {
    const params: StoredProceduresJobsInitialBookingParams = {
      JobId: state.JobId,
    };
    await api.fetchInitialBooking(params);
    if (state.CallTypeId === 2) {
      ui.BookingCompletionMsg = `I will pass this through to our quote department who will call you back with an estimate.\nIf you need to call us back for any reason, the direct number for the quotes department is 0333 241 2466.\n(Press Finish to continue)`;
      bookingCycleMgr.setCurrentBookingCompleted();
    } else if (state.JobStatusId !== 4) {
      ui.BookingCompletionMsg = `Thank you, thats all booked in for you now.\nYour job reference is ${state.JobId}. \nIf you need to call us back for any reason, the direct number for the engineering team is 0330 333 4538.\nAnd if you do need to call us, please do only call this number as its the best way to get directly through to the team.\n(Press Finish to continue)`;
      bookingCycleMgr.setCurrentBookingCompleted();
    } else {
      ui.BookingCompletionMsg = `Booking ${state.JobId} is marked as failed. \n\n(Press Finish to continue)`;
      bookingCycleMgr.setCurrentBookingCancelled();
    }
    const calls = await api.fetchCallByJobId({ jobId: state.JobId });
    if (calls && calls.callId) {
      dispatchSetMultipleState({
        CallId: calls.callId,
        CallDateTimeCreated: calls.dateTimeCreated ? new Date(calls.dateTimeCreated) : undefined,
        CallHAUKSale: calls.haukSale,
      });
      await callSubmit();
    }
  };

  saveFailed = async () => {
    // FAILED
    dispatchSetMultipleState({
      CallOther: 1,
      CallOtherPhoneId: (ui.FailFeedbackReason as RightioWBSAPIModelsOtherPhoneCalls)?.otherPhoneId,
      CallNotes: ui.FailFeedbackValue,
      JobStatusId: 0,
      JobDateTimeOriginalRequired: state.JobDateTimeRequired,
      JobDateTimeLatestArrival: state.JobDateTimeRequired,
      JobDateTimeCommitted: new Date(),
      JobDateTimeUpdated: new Date(),
    });

    // VERIFY WE CAPTURED JOB FAILURE NOTES
    if (state.CallNotes.length === 0) {
      dispatchSetSnackMsgError({
        ProblemMsg: "Please enter a reason for the job failure",
      });
      return false;
    }

    // SAVE JOB OBJECT TO TABLE
    const tableUpdated = await this.updateDBJobsTable();
    if (!tableUpdated) {
      return false;
    }

    const postSaved = await this.postSave();
    if (!postSaved) {
      return false;
    }

    await this.finalizeBooking();

    return true;
  };

  submit = async () => {
    // SUBMIT
    logger.debug(namespace, "submit: Started");
    state.JobDateTimeUpdated = new Date();

    //     // Validation
    //     // ------------------------------

    const isNoGoBackOrQuote = !state.IsAQuote && !state.IsAGoBack?.previousJobId;

    const isFailed = ui.BookingRejectionReason !== null;

    if (isNoGoBackOrQuote && !isFailed) {
      // check if appointment date is in the future and valid
      const isEmergency = state.JobTimeRequirementTypeId === 0;
      const isSameDay = state.JobTimeRequirementTypeId === 1;
      //check if date is in the past days

      const isInPastDays =
        new Date(state?.JobDateTimeRequired || "").toISOString().replace(/T.*/, "") <
        new Date().toISOString().replace(/T.*/, "");
      if (isInPastDays) {
        dispatchSetSnackMsgError({
          ProblemMsg: "Please enter a valid appointment date",
        });
        return false;
      }
      // if emergency or same day, then appointment date can potentially be in the past for hold bookings
      if (isEmergency || isSameDay) {
        const minAvailableAppointmentTime = isEmergency
          ? AppointmentDate.checkAppointmentTimeForEmergency()
          : AppointmentDate.checkAppointmentTime();

        switch (state.JobAppointmentTimeTypeId) {
          case 1:
            if (minAvailableAppointmentTime !== "am") {
              dispatchSetSnackMsgError({
                ProblemMsg: "Appointment date cannot be in the past",
              });
              return false;
            }
            break;

          case 2:
            if (minAvailableAppointmentTime === "eve") {
              dispatchSetSnackMsgError({
                ProblemMsg: "Appointment date cannot be in the past",
              });
              return false;
            }
            break;

          case 3:
            break;

          default:
            dispatchSetSnackMsgError({
              ProblemMsg: "Appointment date cannot be in the past",
            });
            return false;
        }
      }
    }

    const isRequisition = ui.BookingPaymentMethodPaymentMethods?.id === 4;
    const isCompanyValid = state.BookingPaymentMethodCompanyRegistrationAccepted;
    const paymentBooked = ui.BookingPaymentIsBooked;
    // log checking for company registration and requisition
    logger.debug(namespace, "submit: isCompanyValid: " + isCompanyValid);
    if (paymentBooked && isRequisition && !isCompanyValid) {
      dispatchSetSnackMsgError({
        ProblemMsg: "Please validate the company registration number or choose different payment method.",
      });
      return false;
    }

    // log checking for reduced rate
    logger.debug(namespace, `submit: state.RateReductionDiscountId: ${state.ChargeRateReductionDiscountId}`);
    if (paymentBooked && !checkReducedRate()) {
      dispatchSetSnackMsgError({
        ProblemMsg: "Please validate the reduced rate.",
      });
      return false;
    }

    // log checking for promo code
    // logger.debug(namespace, "submit: globals.Discount.discountId: " + globals.Discount.discountId);
    state.JobDiscountId = state.ChargeRateReductionDiscountId;

    // log checking for restricted area
    logger.debug(namespace, "submit: globals.RestrictedArea.restrictedAreaId: ");
    // generate cancellation token
    const token = AddressUtils.cancellationTokens.generateToken();
    const isRestrictedArea = await AddressUtils.lookupBookingRestriction({ ui, token });
    if (paymentBooked && isRestrictedArea && state.RestrictionExpiresIn30Days === -1) {
      dispatchSetSnackMsgError({
        ProblemMsg: "There is restriction in the area.",
      });
      return false;
    }

    // log checking for response time
    logger.debug(namespace, "submit: globals.ResponseTime.responseTimeId: ");
    // generate cancellation token
    const token2 = AddressUtils.cancellationTokens.generateToken();
    if (paymentBooked && !state.JobFailedId && !(await AddressUtils.lookupResponseTime({ ui, token: token2 }))) {
      dispatchSetSnackMsgError({
        ProblemMsg: "Unable to book this job as there is no availability for this postcode area.",
      });
      return false;
    }

    //     // Saving
    //     // ----------------------------------------------------------------------------------
    //     if (DesignerHost.IsValid)
    //     {
    //         DesignerHost.DialogResultOnSave = true;

    //         // Check for specific meta data
    //         // -------------
    //         Type type = DesignerHost.GetType;
    //         if (type.GetProperty("MetaData") is object)
    //         {
    //             int leadId = ToInt(DesignerHost.GetMetaData("LeadId"));
    //             if (leadId > 0)
    //             {
    //                 DesignerHost.GetScaler("EXEC sp_Enquiries_SetJob @LeadId=" + ToSql(leadId) + ", @JobId=" + DesignerHost.Id);
    //             }
    //         }
    //         // -------------

    // Rate and Price
    // -------------
    if (state.ChargeRateAdj === 0 && state.ChargePriceAdj === 0 && isNoGoBackOrQuote) {
      dispatchSetSnackMsgError({
        ProblemMsg: "Please enter a rate or price.",
      });
      return false;
    }

    dispatchSetMultipleState({
      JobRate1: state.ChargeRateAdj,
      JobPrice1: state.ChargePriceAdj,
    });

    // Requisition type
    if (isRequisition && ui.BookingPaymentMethodPaymentRequisitions?.id) {
      state.ChargeRequisitionTypeId = ui.BookingPaymentMethodPaymentRequisitions.id;
    } else {
      state.ChargeRequisitionTypeId = 0;
    }

    //         // Call Types
    //         // -------------------
    if (state.CallTypeId === 2 || state.CallTypeId === 7 || state.CallTypeId === 8 || state.CallTypeId === 9) {
      dispatchSetMultipleState({
        JobIsQuote: true,
        JobPrice1: 0,
        JobRate1: 0,
        JobStatusId: 3, // 3 = New Quote
        CallQuote: 1,
      });
    } else {
      state.JobStatusId = 17;
    } // 17 = Confirmed

    if ((await autoAllocateLookup()) && !state.JobFailedId) {
      state.JobStatusId = 100;
    }
    // Occupancy
    switch (ui.CustomerType) {
      case "landlord": {
        // Landlord
        state.JobIsLandlord = true;
        break;
      }

      case "home-owner": {
        // Privately owned
        state.JobIsPropertyOwner = true;
        break;
      }

      case "tenant": {
        // Tenant
        state.JobIsTenant = true;
        break;
      }
      default: {
        state.JobIsLandlord = true;
        break;
      }
    }

    //         // Go Back Job
    //         // -------------
    if (state.JobGoBackJobId !== 0) {
      dispatchSetMultipleState({
        CallTypeId: 3, // 3 = Go Back
        JobStatusId: 56, // 56 = Go Back Validation
      });
    }
    //         // -------------

    //         // Property Type
    // if (ToInt(DesignerHost.GetReference("ddlPropertyType")) == 1)
    // {
    //     DesignerHost.SetField("Jobs", "IsAHouse", 1);
    // }

    // Popup message
    if (
      ui.BookingPaymentIsBooked ||
      state.CallTypeId === 3 ||
      state.CallTypeId === 7 ||
      state.CallTypeId === 8 ||
      state.CallTypeId === 9
    ) {
      state.JobFailedId = 0;
    }

    // Calls
    // =====================================================================

    if (state.CallTypeId === 3) {
      state.CallGoBack = 1;
    } else if (state.CallTypeId === 2 || state.CallTypeId === 7 || state.CallTypeId === 8 || state.CallTypeId === 9) {
      state.CallQuote = 1;
      // globals.sendSMS = true;
    } else if (state.CallTypeId === 5) {
      // state.JobHa = 0;
      // const intHAUKPolicyId = ToInt(DesignerHost.GetReference("txtHAUKLookup"));
      // this.hAUKPolicyId = intHAUKPolicyId
    } else if (!ui.BookingPaymentIsBooked) {
      if (ui.BookingRejectionReason?.failedId !== 0) {
        dispatchSetMultipleState({
          CallFailed: 1,
          JobStatusId: 4,
          JobWasFailed: true,
        });
        ui.BookingRejectionReason?.failedId && (state.JobFailedId = ui.BookingRejectionReason.failedId);

        // Add metadata for "Same day attendance (SUNDAY)" failure reason
        if (ui.BookingRejectionReason?.failedId === FAILED_REASON_SAME_DAY_ATTENDANCE_SUNDAY) {
          const originalBookingDate = state.JobDateTimeRequired ? new Date(state.JobDateTimeRequired).toISOString().split('T')[0] : 'N/A';
          const failureDate = new Date().toISOString().split('T')[0];
          const metadata = `Original Booking Date: ${originalBookingDate}, Failure Date: ${failureDate}`;
          state.NotesFailed = state.NotesFailed ? `${state.NotesFailed}\n${metadata}` : metadata;
        }
        // globals.sendSMS = true;
      } else {
        dispatchSetSnackMsgError({
          ProblemMsg: "Something went wrong. Please verify that booking payment is completed and try again.",
        });
        return false;
      }
    } else {
      state.CallBooking = 1;
      // globals.sendSMS = true;
    }

    // Reduced Rate
    if (state.ChargeRate !== state.ChargeRateAdj) {
      dispatchSetMultipleState({
        CallReducedRate: 1,
        JobIsDiscounted: true,
        JobDiscountId: state.ChargeRateReductionDiscountId,
      });
    }
    //         DesignerHost.SetField("Jobs", "HowMany", ToInt(DesignerHost.GetReference("ddlQuantity")));
    state.CallNotes = Version.appName();
    //         // =====================================================================

    // globals.engineerId = 0;
    if (ui.BookingPaymentIsBooked && state.ChargeCardRequired) {
      // Required Card
      ui.BookingCardSecured && (state.JobWasCardReceived = true);

      // Card Not Received
      if (!ui.BookingCardSecured) {
        state.JobWasCardReceived = false;
        // this.notes = { card: "Payment for required card not stored" };
      }
    }

    dispatchSetMultipleState({
      JobDateTimeOriginalRequired: new Date(state.JobDateTimeRequired || ""),
      JobDateTimeLatestArrival: new Date(state.JobDateTimeRequired || ""),
      JobDateTimeCommitted: new Date(),
      JobOriginalTimeRequirementTypeId: state.JobTimeRequirementTypeId,
      JobDiscountId: state.ChargeRateReductionDiscountId,
    });

    // SAVE JOB OBJECT TO TABLE
    // SAVE JOB OBJECT TO TABLE
    const tableUpdated = await this.updateDBJobsTable();
    if (!tableUpdated) {
      return false;
    }

    const postSaved = await this.postSave();
    if (!postSaved) {
      return false;
    }
    await this.finalizeBooking();

    return true;
  };

  saveToLocalStorage() {
    const callback = () => {
      this.saveIndexedDBOnExit({
        page: "BookingForm",
        action: "saveToStorage",
        message: "Booking saved",
        reason: "Change of Job object state",
        booking: state.JobId,
      });
    };

    debounceStorage.addOrExecute({ name: `saveToStorage-${state.JobId}`, delay: 50, callback });
  }

  saveIndexedDBOnExit = async (source?: any) => {
    // save only if the job is having a jobId
    if (state.JobId > 0) {
      const saveObj: JobI.SaveJobObject = {
        UI_STATE: ObjectsOperations.deepCopyObjects(
          ui,
          ["CallMeBacksQueue"],
          ["TabsList", "HelperText"],
          ["serviceAgreementExcessId", "excess"]
        ),
        TEMP_STATE: ObjectsOperations.typeSafeStructuredClone(temp),
        STATE_STATE: ObjectsOperations.deepCopyObjects(state, [
          "News",
          "UsersStatistics",
          "UsersStatisticsYesterday",
          // "IsAuthenticated",
          "NavMenuCollapsed",
          "UserId",
          "BOOKING_DATA_SYNC",
        ]),
        QUESTIONS_STATE: {
          answers: ObjectsOperations.typeSafeStructuredClone(
            Object.values(questionsUtils.getQuestions()).map((q) => ({
              answer: q.answer,
              required: q?.required ?? undefined,
            }))
          ),
          jobTypeCode: state.JobTypeCode,
        },
        SA_STATE: serviceAgreement.toObject(),
        // SA_STATE: ObjectsOperations.deepCopyObjects(serviceAgreement),
        jobId: state.JobId,
        statusId: state.JobStatusId,
        failedId: state.JobFailedId,
        source,
        userId: state.UserId,
        dateSaved: new Date(),
      };

      await serviceManager.createServicePromise({
        serviceName: "BOOKING_DATA_SYNC",
        serviceData: {
          origin: "MAIN_THREAD",
          command: "SAVE_TO_INDEXED_DB",
          payload: saveObj,
        },
      });

      // await StorageUtils.setValueInStoreInIndexedDB({ database: "BOOKINGS", tableName: "Booking", value: saveObj });
      if (source && source.action !== "saveToStorage") {
        if (
          source.reason === "Page refresh/close" ||
          source.action === "activeStep" ||
          source.reason === "New Booking" ||
          source.reason === "In Progress Closed" ||
          source.reason === "Booking Failed" ||
          source.reason === "Booking Completed"
        ) {
          serviceManager.sendMessageToWorker({
            serviceName: "BOOKING_DATA_SYNC",
            serviceData: {
              origin: "MAIN_THREAD",
              command: "SYNC_TO_DB_JSON",
              payload: JSON.stringify(saveObj),
            },
          });
        }
      }
    }
  };

  exportToObj = () => {
    const obj: RightioWBSAPIModelsJobPatchInput = {
      accountCode: state.Account?.accountCode,
      addedToMIS: state.JobAddedToMIS,
      allocatedBy: state.JobAllocatedBy,
      amountPaid: state.JobAmountPaid,
      appointmentTimeTypeId: state.JobAppointmentTimeTypeId,
      areaNumber: state.JobAreaNumber,
      boilerAge: state.JobBoilerAge,
      boilerInWorkingOrder: state.JobBoilerInWorkingOrder,
      bookingSourceId: state.JobBookingSourceId,
      callTypeId: state.CallTypeId,
      cancelCode: state.JobCancelCode,
      chequeCardExpiry: getISODate(state.JobChequeCardExpiry),
      chequeCardNumber: state.JobChequeCardNumber,
      companyRegistrationName: state.JobCompanyRegistrationName,
      companyRegistrationNumber: state.JobCompanyRegistrationNumber,
      complAccountType: state.JobComplAccountType,
      complJobTypeCode: state.JobComplJobTypeCode,
      complTradeCode: state.JobComplTradeCode,
      county: state.JobCounty,
      customerCLI: state.JobCustomerCLI,
      customerForename: state.JobCustomerForename,
      customerReference: state.JobCustomerReference,
      customerSurname: state.JobCustomerSurname,
      customerTitle: state.JobCustomerTitle,
      dateReceived: getISODate(state.JobDateReceived),
      dateTimeAllocated: getISODate(state.JobDateTimeAllocated),
      dateTimeCancelled: getISODate(state.JobDateTimeCancelled),
      dateTimeCommitted: getISODate(state.JobDateTimeCommitted),
      dateTimeCompleted: getISODate(state.JobDateTimeCompleted),
      dateTimeEstimated: getISODate(state.JobDateTimeEstimated),
      dateTimeFailed: getISODate(state.JobDateTimeFailed),
      dateTimeLatestArrival: getISODate(state.JobDateTimeLatestArrival),
      dateTimeOriginalRequired: getISODate(state.JobDateTimeOriginalRequired),
      dateTimeReceived: getISODate(state.JobDateTimeReceived),
      dateTimeRequired: getISODate(state.JobDateTimeRequired),
      dateTimeStatus: getISODate(state.JobDateTimeStatus),
      dateTimeUpdated: getISODate(state.JobDateTimeUpdated),
      detailedSource: state.JobDetailedSource,
      discountId: state.JobDiscountId,
      duplicateJobId: state.JobDuplicateJobId,
      emailAddress: state.JobEmailAddress,
      engineerId: state.JobEngineerId,
      failedId: state.JobFailedId,
      gclid: state.JobGCLID,
      generalStr1: state.JobGeneralStr1,
      generalStr4: state.JobGeneralStr4,
      goBackJobId: state.JobGoBackJobId,
      haveOfferedServiceAgreement: state.JobHaveOfferedServiceAgreement,
      haveReadTandCs: state.JobHaveReadTandCs,
      isAdvanceBooking: state.JobIsAdvanceBooking,
      isAHouse: state.JobIsAHouse,
      isAppointmentFixed: state.JobIsAppointmentFixed,
      isCallMeBack: state.JobIsCallMeBack,
      isCommercial: state.JobIsCommercial,
      isCompetitorReferral: state.JobIsCompetitorReferral,
      isDifferentGoBackEngineer: state.JobIsDifferentGoBackEngineer,
      isDiscounted: state.JobIsDiscounted,
      isInterestedInCareClub: state.JobIsInterestedInCareClub,
      isLandlord: state.JobIsLandlord,
      isOkToMarket: state.JobIsOkToMarket,
      isPerHalfHour: state.JobIsPerHalfHour,
      isPropertyOwner: state.JobIsPropertyOwner,
      isQuote: state.JobIsQuote,
      isTenant: state.JobIsTenant,
      jobChargeId: state.JobChargeId,
      jobTypeCode: state.JobTypeCode,
      labourValue: state.JobLabourValue,
      locality: state.JobLocality,
      materialsValue: state.JobMaterialsValue,
      notes: this.notes,
      organisation: state.JobOrganisation,
      originalTimeRequirementTypeId: state.JobOriginalTimeRequirementTypeId,
      partsSupplied: state.JobPartsSupplied,
      paymentMethodId: state.JobPaymentMethodId,
      paymentTaken: state.JobPaymentTaken,
      paymentType: state.JobPaymentType,
      postcode: state.JobPostcode,
      postcodeArea: state.JobPostcodeArea,
      postcodeDistrict: state.JobPostcodeDistrict,
      postcodeSector: state.JobPostcodeSector,
      price1: state.JobPrice1,
      price2: state.JobPrice2,
      price3: state.JobPrice3,
      property: state.JobOrganisation ? state.JobProperty && state.JobProperty !== 'N/A' ? `${state.JobOrganisation}, ${state.JobProperty}` : state.JobOrganisation : state.JobProperty,
      rate1: state.JobRate1,
      rate2: state.JobRate2,
      rate3: state.JobRate3,
      serviceAgreementDeclinedId: state.JobServiceAgreementDeclinedId,
      serviceAgreementId: state.JobServiceAgreementId,
      soldBy: state.JobSoldBy,
      statusId: state.JobStatusId,
      street: state.JobStreet,
      sundriesValue: state.JobSundriesValue,
      telephoneFax: state.JobTelephoneFax,
      telephoneLandline: state.JobTelephoneLandline,
      telephoneMobile: state.JobTelephoneMobile,
      timeRequirementTypeId: state.JobTimeRequirementTypeId,
      totalCharges: state.JobTotalCharges,
      totalPayments: state.JobTotalPayments,
      town: state.JobTown,
      tradeCode: state.JobTradeCode,
      unconvertedFailedCode: state.JobUnconvertedFailedCode,
      vatValue: state.JobVATValue,
      wasCancelled: state.JobWasCancelled,
      wasCardReceived: state.JobWasCardReceived,
      wasFailed: state.JobWasFailed,
    };
    return obj;
  };

  loadIndexedDB = async (jobId: number, loadFunction: () => Promise<void>) => {
    // create promise to assign jobObject
    const jobObject = (await serviceManager.createServicePromise({
      serviceName: "BOOKING_DATA_SYNC",
      serviceData: {
        command: "LOAD_FROM_INDEXED_DB",
        origin: "MAIN_THREAD",
        payload: jobId,
      },
    })) as JobI.SaveJobObject;

    // if jobObject is not null then import all states to reducers
    if (jobObject) {
      // import all states to reducers
      if (jobObject.STATE_STATE) {
        importStateReducer(ObjectsOperations.typeSafeStructuredClone(jobObject.STATE_STATE));
        if (jobObject.SA_STATE) {
          // special rehydration for serviceAgreement recreating the serviceAgreement object with all subclasses and getters, setters, etc
          serviceAgreement.objectAssign(
            serviceAgreement,
            ObjectsOperations.typeSafeStructuredClone(jobObject.SA_STATE)
          );
        }
        // delete STATE field
      }
      if (jobObject.UI_STATE) {
        // hydrate UI reducer
        importUIReducer(ObjectsOperations.typeSafeStructuredClone(jobObject.UI_STATE));
        // delete UI field
      }
      if (jobObject.TEMP_STATE) {
        // hydrate TEMP reducer
        importTempReducer(ObjectsOperations.typeSafeStructuredClone(jobObject.TEMP_STATE));
        // delete TEMP field
      }
      if (jobObject.QUESTIONS_STATE) {
        // hydrate QUESTIONS reducer
        questionsUtils.importQuestionsAnswers(
          ObjectsOperations.typeSafeStructuredClone(jobObject.QUESTIONS_STATE),
          ObjectsOperations.typeSafeStructuredClone(state.RequiredOption10Answer)
        );
      }
      deleteObjectProperties(jobObject);
      await loadFunction();
    }
  };

  private updateDBJobsTable = async () => {
    const pureObject = this.exportToObj();
    delete pureObject.dateTimeReceived;

    const patchedJob = await api.fetchJobsPatch(state.JobId, pureObject);
    if (patchedJob?.jobId && patchedJob.jobId > 0) {
      dispatchSetSnackMsgSuccess({
        ProblemMsg: "Job Patched",
      });
    } else {
      dispatchSetSnackMsgError({
        ProblemMsg: "Error updating job in DB",
      });
      return false;
    }

    const patchedCall = await callSubmit();
    if (!patchedCall) {
      dispatchSetSnackMsgError({
        ProblemMsg: "Error updating call in DB",
      });
      return false;
    }

    return true;
  };
}

const job = new Job();

declare global {
  interface Window {
    JOB: any;
  }
}

window.JOB = job;
export default job;
